import * as math from "mathjs"
const obj2str = (o) => Object.prototype.toString.call(o);
const isPlainObject = (o) => obj2str(o) === "[object Object]";
const isArray = (o) => obj2str(o) === "[object Array]";
const isNumber = (o) => obj2str(o) === "[object Number]";
const isString = (o) => obj2str(o) === "[object String]";

// 随机id
const genId = (prefix = "") =>
  `${prefix}${Number(
    Math.random()
      .toString()
      .substr(3, 8) + Date.now()
  ).toString(36)}`;

const treeToList = (data, newArr, pid) => {
  newArr = newArr || [];

  data.forEach(function(t) {
    if (!t.parentId && t.parentId != 0) {
      t.parentId = pid;
    }

    newArr.push(t);

    if (t.children && t.children.length) {
      treeToList(t.children, newArr, t.id);
    }
  });

  return newArr;
};

const compare = (property, reverse) => {
  return function(a, b) {
    if (reverse) {
      return b[property] - a[property];
    } else {
      return a[property] - b[property];
    }
  };
};

// 生成数据树
const getTreeData = (obj) => {
  let datas = [];
  let pid = "parentId";
  let cid = "id";

  if (Object.prototype.toString.call(obj) == "[object Object]") {
    datas = obj.list || [];
    pid = obj.pid || pid;
    cid = obj.cid || cid;
  } else if (Object.prototype.toString.call(obj) == "[object Array]") {
    datas = obj;
  } else {
    throw new Error("参数必须是Object或者Array！");
  }

  let temptree = [],
    tree = [],
    items = [];

  for (let i in datas) {
    if (!temptree[datas[i][cid]]) {
      let trow = {
        ...datas[i],
        children: [],
      };

      temptree[datas[i][cid]] = trow;

      items.push(trow);
    }
  }

  for (let j in items) {
    if (temptree[items[j][pid]]) {
      temptree[items[j][pid]]["children"].push(temptree[items[j][cid]]);
    } else {
      tree.push(temptree[items[j][cid]]);
    }
  }

  temptree = null;
  items = null;

  return tree;
};

const getDeepTree = (obj, parentNode) => {
  let rs = obj.list
  let pidFields = obj.pid || 'parentId'
  let valueFields = obj.cid || 'id'
  parentNode = parentNode || {}
  const pid = parentNode[valueFields] || ''
  let newRs = []
  if (rs && rs.length) {
    rs.map((v) => {
      const parentValue = v[pidFields] || ''
      if (parentValue == pid) {
        if (!parentValue || parentValue === '0') {
          v.depth = 0
        }
        const parentDepth = parentNode.depth || 0
        v.depth = parentDepth + 1
        v.children = rs.filter((vv) => vv[pidFields] == v[valueFields])
        v.children.map(t=>{ return t.sourceId = v.id})
        if (v.children && v.children.length) {
          getDeepTree(obj, v)
        }
        newRs.push(v)
      }
    })
  }
  return newRs
}

// 数组转map
const arr2map = (data, key = "code") => {
  return [].concat(data).reduce((res, cur) => {
    res[cur[key]] = cur;
    return res;
  }, {});
};

// 数组转map
const str2arr = (val, sq = ",") => {
  if (isString(val) || isNumber(val)) {
    return String(val)
      .split(sq)
      .filter((v) => v);
  } else {
    return [];
  }
};

// 数组排序
const arrSort = (data, field, reverse) => data.sort(compare(field, reverse));

const getRootPid = (data) => {
  let rootId = "";

  data.forEach(function(t) {
    if (rootId || rootId === 0) {
      rootId = rootId < t.parentId ? rootId : t.parentId;
    } else {
      rootId = t.parentId;
    }
  });

  return rootId;
};

// ex: getQueryString('k1', '?k1=v1&k2=v2') => v1
const getQueryString = (name, str) => {
  const reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
  const search = location.hash.split("?")[1] || "";
  const r = (str || "?" + search).substr(1).match(reg);
  if (r != null) return decodeURI(r[2]);
  return null;
};

const getOffsetTopByBody = (el) => {
  let offsetTop = 0;
  while (el && el.tagName !== "BODY") {
    offsetTop += el.offsetTop;
    el = el.offsetParent;
  }
  return offsetTop;
};

// 个位数补零
const zeroPadding = (n) => (+n > 9 ? n : "0" + +n);

// 获取时间戳
// getTimestamp([2019, 1, 1]) => 1546272000000 or getTimestamp(['2019', '01', '01', '00', '00']) => 1546272000000
// getTimestamp('2019年1月1日') => 1546272000000 or getTimestamp('2019年01月01日 00:00:00') => 1546272000000
// getTimestamp('2019-1-1') => 1546272000000 or getTimestamp('2019-01-01 00:00:00') => 1546272000000
// getTimestamp('2019/1/1') => 1546272000000 or getTimestamp('2019/01/01 00:00:00') => 1546272000000
// getTimestamp('2019,1,1') => 1546272000000 or getTimestamp('2019,01,01 00:00:00') => 1546272000000
const getTimestamp = (date) => {
  if (typeof date == "number") {
    return date;
  } else if (date instanceof Date) {
    return date.getTime();
  } else if (typeof date == "string" || Array.isArray(date)) {
    let dates = [];
    if (typeof date == "string") {
      dates = date.split(/[^0-9]/).filter((v) => v);
    } else {
      dates = date;
    }
    let [y, M = 0, D = 1, h = 0, m = 0, s = 0] = dates;
    const zp = (n) => (+n > 9 ? n : "0" + +n);
    return new Date(
      `${y}/${zp(M)}/${zp(D)} ${zp(h)}:${zp(m)}:${zp(s)}`
    ).getTime();
  } else {
    return new Date().getTime();
  }
};

const urlEncode = (obj) => {
  const keys = Object.keys(obj).filter((k) => obj[k]);
  return keys
    .map((k) =>
      "".concat(encodeURIComponent(k), "=").concat(encodeURIComponent(obj[k]))
    )
    .join("&");
};

const nodeToString = ( node ) => {  
  var tmpNode = document.createElement( "div" ); 
  tmpNode.appendChild( node.cloneNode( true ) );  
  var str = tmpNode.innerHTML;  
  tmpNode = node = null;
  return str;  
 }

const discriCard = (UUserCard) => {
  UUserCard.substring(6, 10) + "-" + UUserCard.substring(10, 12) + "-" + UUserCard.substring(12, 14);
  let rs = {}
  //获取性别 
  if (parseInt(UUserCard.substr(16, 1)) % 2 == 1) {
    rs.gender = '男'
    //是男则执行代码 ... 
  } else {
    rs.gender = '女'
    //是女则执行代码 ... 
  }
  //获取年龄 
  var myDate = new Date();
  var month = myDate.getMonth() + 1;
  var age = myDate.getFullYear() - UUserCard.substring(6, 10) - 1;
  if (UUserCard.substring(10, 12) < month || UUserCard.substring(10, 12) == month) {
    age++;
  }
  //年龄 age 
  rs.age = age
  return [rs.gender, rs.age]
}
const idCardNoUtil = {
  /*省,直辖市代码表*/
  provinceAndCitys: {11:"北京",12:"天津",13:"河北",14:"山西",15:"内蒙古",21:"辽宁",22:"吉林",23:"黑龙江",
      31:"上海",32:"江苏",33:"浙江",34:"安徽",35:"福建",36:"江西",37:"山东",41:"河南",42:"湖北",43:"湖南",44:"广东",
      45:"广西",46:"海南",50:"重庆",51:"四川",52:"贵州",53:"云南",54:"西藏",61:"陕西",62:"甘肃",63:"青海",64:"宁夏",
      65:"新疆",71:"台湾",81:"香港",82:"澳门",91:"国外"},

  /*每位加权因子*/
  powers: ["7","9","10","5","8","4","2","1","6","3","7","9","10","5","8","4","2"],

  /*第18位校检码*/
  parityBit: ["1","0","X","9","8","7","6","5","4","3","2"],

  /*性别*/
  genders: {male:"M",female:"F"},

  /*校验地址码*/
  checkAddressCode: function(addressCode){
      var check = /^[1-9]\d{5}$/.test(addressCode);
      if(!check) return false;
      if(idCardNoUtil.provinceAndCitys[parseInt(addressCode.substring(0,2))]){
          return true;
      }else{
          return false;
      }
  },

  /*校验日期码*/
  checkBirthDayCode: function(birDayCode){
      var check = /^[1-9]\d{3}((0[1-9])|(1[0-2]))((0[1-9])|([1-2][0-9])|(3[0-1]))$/.test(birDayCode);
      if(!check) return false;
      var yyyy = parseInt(birDayCode.substring(0,4),10);
      var mm = parseInt(birDayCode.substring(4,6),10);
      var dd = parseInt(birDayCode.substring(6),10);
      var xdata = new Date(yyyy,mm-1,dd);
      if(xdata > new Date()){
          return false;//生日不能大于当前日期
      }else if ( ( xdata.getFullYear() == yyyy ) && ( xdata.getMonth () == mm - 1 ) && ( xdata.getDate() == dd ) ){
          return true;
      }else{
          return false;
      }
  },

  /*计算校检码*/
  getParityBit: function(idCardNo){
      var id17 = idCardNo.substring(0,17);
      /*加权 */
      var power = 0;
      for(var i=0;i<17;i++){
          power += parseInt(id17.charAt(i),10) * parseInt(idCardNoUtil.powers[i]);
      }
      /*取模*/
      var mod = power % 11;
      return idCardNoUtil.parityBit[mod];
  },

  /*验证校检码*/
  checkParityBit: function(idCardNo){
      var parityBit = idCardNo.charAt(17).toUpperCase();
      if(idCardNoUtil.getParityBit(idCardNo) == parityBit){
          return true;
      }else{
          return false;
      }
  },

  /*校验15位或18位的身份证号码*/
  checkIdCardNo: function(idCardNo){
      //15位和18位身份证号码的基本校验
      var check = /^\d{15}|(\d{17}(\d|x|X))$/.test(idCardNo);
      if(!check) return false;
      //判断长度为15位或18位
      if(idCardNo.length==15){
          return idCardNoUtil.check15IdCardNo(idCardNo);
      }else if(idCardNo.length==18){
          return idCardNoUtil.check18IdCardNo(idCardNo);
      }else{
          return false;
      }
  },

  //校验15位的身份证号码
  check15IdCardNo: function(idCardNo){
      //15位身份证号码的基本校验
      var check = /^[1-9]\d{7}((0[1-9])|(1[0-2]))((0[1-9])|([1-2][0-9])|(3[0-1]))\d{3}$/.test(idCardNo);
      if(!check) return false;
      //校验地址码
      var addressCode = idCardNo.substring(0,6);
      check = idCardNoUtil.checkAddressCode(addressCode);
      if(!check) return false;
      var birDayCode = '19' + idCardNo.substring(6,12);
      //校验日期码
      check = idCardNoUtil.checkBirthDayCode(birDayCode);
      if(!check) return false;
      //验证校检码
      return idCardNoUtil.checkParityBit(idCardNo);
  },

  //校验18位的身份证号码
  check18IdCardNo: function(idCardNo){
      //18位身份证号码的基本格式校验
      var check = /^[1-9]\d{5}[1-9]\d{3}((0[1-9])|(1[0-2]))((0[1-9])|([1-2][0-9])|(3[0-1]))\d{3}(\d|x|X)$/.test(idCardNo);
      if(!check) return false;
      //校验地址码
      var addressCode = idCardNo.substring(0,6);
      check = idCardNoUtil.checkAddressCode(addressCode);
      if(!check) return false;
      //校验日期码
      var birDayCode = idCardNo.substring(6,14);
      check = idCardNoUtil.checkBirthDayCode(birDayCode);
      if(!check) return false;
      //验证校检码
      return idCardNoUtil.checkParityBit(idCardNo);
  },

  formateDateCN: function(day){
      var yyyy =day.substring(0,4);
      var mm = day.substring(4,6);
      var dd = day.substring(6);
      return yyyy + '-' + mm +'-' + dd;
  },

  //获取信息
  getIdCardInfo: function(idCardNo){
      var idCardInfo = {
          gender:"",  //性别
          birthday:"" // 出生日期(yyyy-mm-dd)
      };
      var aday;
      if(idCardNo.length==15){
          aday = '19' + idCardNo.substring(6,12);
          idCardInfo.birthday=idCardNoUtil.formateDateCN(aday);
          if(parseInt(idCardNo.charAt(14))%2==0){
              idCardInfo.gender=idCardNoUtil.genders.female;
          }else{
              idCardInfo.gender=idCardNoUtil.genders.male;
          }
      }else if(idCardNo.length==18){
          aday = idCardNo.substring(6,14);
          idCardInfo.birthday=idCardNoUtil.formateDateCN(aday);
          if(parseInt(idCardNo.charAt(16))%2==0){
              idCardInfo.gender=idCardNoUtil.genders.female;
          }else{
              idCardInfo.gender=idCardNoUtil.genders.male;
          }

      }
      return idCardInfo;
  },

  /*18位转15位*/
  getId15: function(idCardNo){
      if(idCardNo.length==15){
          return idCardNo;
      }else if(idCardNo.length==18){
          return idCardNo.substring(0,6) + idCardNo.substring(8,17);
      }else{
          return null;
      }
  },

  /*15位转18位*/
  getId18: function(idCardNo){
      if(idCardNo.length==15){
          var id17 = idCardNo.substring(0,6) + '19' + idCardNo.substring(6);
          var parityBit = idCardNoUtil.getParityBit(id17);
          return id17 + parityBit;
      }else if(idCardNo.length==18){
          return idCardNo;
      }else{
          return null;
      }
  }
};

const nextDay = (day) => {
  var date1=null
  if (day) {
    day = day.replace(/-/g, '/')
    date1 = new Date(day)
  } else {
    date1 = new Date()
  }
  date1.setDate(date1.getDate()+1);
  var year = date1.getFullYear();
  var mon = date1.getMonth() + 1
  var dates = date1.getDate()
  return year + '-' + zeroPadding(mon) + '-' + zeroPadding(dates)
}

const toDay = (day) => {
  var date1=null
  if (day) {
    day = day.replace(/-/g, '/')
    date1 = new Date(day)
  } else {
    date1 = new Date()
  }
  var year = date1.getFullYear();
  var mon = date1.getMonth() + 1
  var dates = date1.getDate()
  return year + '-' + zeroPadding(mon) + '-' + zeroPadding(dates)
}

const beforeDay = (day) => {
  var date1=null
  if (day) {
    day = day.replace(/-/g, '/')
    date1 = new Date(day)
  } else {
    date1 = new Date()
  }
  date1.setDate(date1.getDate()-1);
  var year = date1.getFullYear();
  var mon = date1.getMonth() + 1
  var dates = date1.getDate()
  return year + '-' + zeroPadding(mon) + '-' + zeroPadding(dates)
}

const formatDates = (val) => {
  let str = ''
  if (val) {
    val = val.replace(/-/g, '/')
    var date1 = new Date(val);
    if (date1 == 'Invalid Date') {
      str = val
    } else {
      var year = date1.getFullYear();
      var mon = date1.getMonth() + 1
      var dates = date1.getDate()
      str = zeroPadding(year) + '-' + zeroPadding(mon) + '-' + zeroPadding(dates)
    }
  }
  return str
}

const fullDate = () => {
  let str = ''
  var date1 = new Date();
  var year = date1.getFullYear();
  var mon = date1.getMonth() + 1
  var dates = date1.getDate()
  var hours = date1.getHours()
  var mins = date1.getMinutes()
  var sec = date1.getSeconds()
  str = zeroPadding(year) + '-' + zeroPadding(mon) + '-' + zeroPadding(dates) + ' ' + zeroPadding(hours) + ':' + zeroPadding(mins) + ':' + zeroPadding(sec)
  return str
}


const colorutils = (color, opacity) => {
  // 将rgb或者十六进制颜色统一转成hsl模式
  function allhsl(color){
      // 首先对颜色判断，如果是rgb则走rgb模式，因为#号是特殊字符，网址传参都有限制，所以不判断#
      if(color.indexOf('rgb') != -1){
          var start = color.indexOf('(')+1;
          var startval = color.substr(color.indexOf('(')+1)
          var end = startval.indexOf(')');
          var val = startval.substr(0, end)
          var colorarr = val.split(",");
          return rgbtohsl(colorarr[0],colorarr[1],colorarr[2])
      } else {
          return colorToRgb(color);
      }
  }
  // 然后就是转化成处理后的颜色 如果传rgb就返rgb模式，如果是十六进制就返十六进制
  function resultRgb(color, opacity){
      var arr = allhsl(color);
      var result = hsltorgb(arr[0], arr[1], opacity);
      if(color.indexOf('rgb') != -1){
          return "rgb("+result[0]+","+result[1]+","+result[2]+")";
      } else {
          return colorToHex(result);
      }
  }
  // 将十六进制转成rgb
  function colorToRgb(color){
      if(color.indexOf("#") != -1){
          color = color.replace("#", "", color)
      }
      var color1 = parseInt(color.substr(0, 2), 16);
      var color2 = parseInt(color.substr(2, 2), 16);
      var color3 = parseInt(color.substr(4, 2), 16);
      var str = "rgb("+color1+","+color2+","+color3+")";
      // console.log(str)
      return rgbtohsl(color1, color2, color3);
  }
  // 将rgb转成hsl模式
  function rgbtohsl(r,g,b){
      r=math.divide(r, 255);
      g=math.divide(g, 255);
      b=math.divide(b, 255);
  
      var min=Math.min(r,g,b);
      var max=Math.max(r,g,b);
      var l= math.divide(math.add(min,max), 2);
      var difference = math.subtract(max, min);
      var h,s,l;
      if(max==min){
          h=0;
          s=0;
      }else{
          s=l>0.5? math.divide(difference, math.subtract(math.subtract(2.0, max), min)) : math.divide(difference, math.add(max,min));
          switch(max){
              case r: h= math.add(math.divide(math.subtract(g, b), difference), (g < b ? 6 : 0));break;
              case g: h=math.add(2.0, math.divide(math.subtract(b, r), difference));break;
              case b: h=math.add(4.0, math.divide(math.subtract(r, g), difference));break;
          }
          h=Math.round(math.multiply(h, 60));
      }
      s=Math.round(math.multiply(s, 100));//转换成百分比的形式
      l=Math.round(math.multiply(l, 100));
      return [h,s,l];
  }
  // 将hsl模式转成rgb
  function hsltorgb(h,s,l){
      var h=math.divide(h, 360);
      var s=math.divide(s, 100);
      var l=math.divide(l, 100);
      var rgb=[];
  
      if(s==0){
          rgb=[Math.round(math.multiply(l, 255)),Math.round(math.multiply(l, 255)),Math.round(math.multiply(l, 255))];
      }else{
          var q=l>=0.5?math.subtract(math.add(l, s), math.multiply(l, s)):math.multiply(l, math.add(1, s));
          var p=math.subtract(math.multiply(2, l), q);
          var tr=rgb[0]=math.add(h, math.divide(1, 3));
          var tg=rgb[1]=h;
          var tb=rgb[2]=math.subtract(h, math.divide(1, 3));
          for(var i=0; i<rgb.length;i++){
              var tc=rgb[i];
              if(tc<0){
                  tc=math.add(tc, 1);
              }else if(tc>1){
                  tc=math.subtract(tc, 1);
              }
              switch(true){
                  case (tc<math.divide(1, 6)):
                      tc=math.add(p, math.multiply(math.multiply(math.subtract(q, p), 6), tc));
                      break;
                  case (math.divide(1, 6)<=tc && tc<0.5):
                      tc=q;
                      break;
                  case (0.5<=tc && tc<math.divide(2, 3)):
                      tc=math.add(p, math.multiply(math.subtract(q, p), math.subtract(4, math.multiply(6, tc))));
                      break;
                  default:
                      tc=p;
                      break;
              }
              rgb[i]=Math.round(math.multiply(tc, 255));
          }
      }
      
      return rgb;
  }
  // rgb转十六进制 color 为[r,b,g]的格式 
  function colorToHex(color){
      function componentToHex(c) {
        var hex = c.toString(16);
        return hex.length == 1 ? "0" + hex : hex;
      }
      return "#" + componentToHex(color[0]) + componentToHex(color[1]) + componentToHex(color[2]);
  }
  return resultRgb(color, opacity)
}

const countWords = (val) => {
  // 统计字符数
  var wordCount = val || 0
 
  // 转换为不同的单位
  if (wordCount >= 10000) {
    let value = (wordCount / 10000).toFixed(1) * 1
    if (value >= 10000) {
      wordCount = (value / 10000).toFixed(1) * 1 + '亿';
    } else {
      wordCount = value + '万';
    }
  } else if (wordCount >= 1000) {
    wordCount = (wordCount / 1000).toFixed(1) * 1 + '千';
  }
 
  return wordCount;
}

export {
  isPlainObject,
  isArray,
  isNumber,
  isString,
  genId,
  treeToList,
  urlEncode,
  getTreeData,
  getDeepTree,
  arr2map,
  str2arr,
  arrSort,
  getRootPid,
  getQueryString,
  getOffsetTopByBody,
  zeroPadding,
  getTimestamp,
  nodeToString,
  discriCard,
  idCardNoUtil,
  nextDay,
  toDay,
  beforeDay,
  formatDates,
  colorutils,
  countWords,
  fullDate
};
